import React from 'react'

import clsx from 'clsx'

import Button, { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import Typography from 'components/Typography'

import DialogActions from './components/DialogActions'
import DialogContent from './components/DialogContent'
import DialogRoot from './components/DialogRoot'
import DialogTitle from './components/DialogTitle'

import classes from './Dialog.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const Dialog = ({
  children,
  contentClassName,
  fullScreen = false,
  fullWidth = true,
  isOpen = false,
  maxWidth = 'sm',
  onClose = noop,
  primaryButton = null,
  secondaryButton = null,
  title = '',
  isSeoFriendly = false,
}) => {
  const handleClose = () => {
    onClose()
  }

  const hasActions = !!(primaryButton || secondaryButton)

  return (
    <DialogRoot
      className="Dialog"
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      onClose={handleClose}
      isOpen={isOpen}
      isSeoFriendly={isSeoFriendly}
    >
      {title && (
        <DialogTitle className={classes.title}>
          <Typography component="h3" variant="heading-sm">
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            data-testid="dialog-close-button"
            onClick={handleClose}
            className={classes.closeIconButton}
          >
            <Icon icon="times" className={classes.closeIcon} size={24} />
          </IconButton>
        </DialogTitle>
      )}
      {children && (
        <DialogContent className={clsx(classes.content, contentClassName)} dividers>
          {children}
        </DialogContent>
      )}
      {hasActions && (
        <DialogActions className={classes.actions}>
          {primaryButton && (
            <Button
              rel={primaryButton.rel}
              target={primaryButton.self ? null : '_blank'}
              href={primaryButton.href}
              onClick={primaryButton.onClick}
              color={primaryButton.color || 'primary'}
            >
              {primaryButton.label}
            </Button>
          )}
          {secondaryButton && (
            <Button
              rel={secondaryButton.rel}
              target={secondaryButton.self ? null : '_blank'}
              href={secondaryButton.href}
              onClick={secondaryButton.onClick}
              color={secondaryButton.color || 'primary'}
            >
              {secondaryButton.label}
            </Button>
          )}
        </DialogActions>
      )}
    </DialogRoot>
  )
}

export default Dialog
